import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  itemName,
  isLoading = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: theme => `1px solid ${theme.palette.error.light}`
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: 1,
        color: 'error.main',
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
        py: 2
      }}>
        <WarningAmberRoundedIcon color="error" fontSize="medium" />
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 3 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ 
            flexShrink: 0,
            color: 'error.main',
            mt: 0.5
          }}>
          </Box>
          <Box>
            <DialogContentText sx={{ mb: 1 }}>
              {description}
            </DialogContentText>
            {itemName && (
              <Typography variant="body1" fontWeight={500}>
                "{itemName}"
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        px: 3, 
        py: 2,
        borderTop: theme => `1px solid ${theme.palette.divider}`
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          disabled={isLoading}
          sx={{
            minWidth: 100,
            textTransform: 'none'
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          sx={{
            minWidth: 100,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'error.dark',
              boxShadow: 'none'
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;